/* src/app/views/display/components/display-section/display-template-collection-section/display-menu-section-inside-template-collection/display-menu-section-inside-template-collection-body/display-menu-section-inside-template-collection-options/display-menu-section-inside-template-collection-options.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=display-menu-section-inside-template-collection-options.component.css.map */
